export const getRelatedLoansApi = (params, query) => {

    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/related-loan${queryString ? `?${queryString}` : ""}`;
};
export const addRelatedLoansApi = (params) => {
    return `lease/${params?.leaseSlug}/related-loan`;
};
export const updateRelatedLoansApi = (params) => {
    return `lease/${params?.leaseSlug}/related-loan/${params?.slug}`;
};
export const deleteRelatedLoansApi = (params) => {
    return `lease/${params?.leaseSlug}/related-loan`;
};
export const exportRelatedLoansApi = (leaseId) => {
    return `lease/${leaseId}/export/related-loan`;
};

export const relatedLoansfileUploadPostApi = (relatedLoans_slug) => {
    return `/get-pre-signed-url/related_loan/${relatedLoans_slug}`;
};

export const relatedLoansAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/related_loan/${attachments_slug}`
}
